import { gql, useLazyQuery } from "@apollo/client";
import { useState } from "react";

const GET_LINKSERVICE_NEAR_QUERY = gql`
  query getLinkServiceNear($input: GetLinkServiceNearInput!) {
    getLinkServiceNear(input: $input) {
      ok
      err
      linkservice {
        id
        name
        link
        description
        latitude
        longitude
        address
        distance
        isActive
      }
    }
  }
`;

export interface GetLinkServiceNearQuery {
  getLinkServiceNear: {
    ok: boolean;
    err: string;
    linkservice: {
      id: string;
      name: string;
      description: string;
      latitude: number;
      longitude: number;
      address: string;
      distance: number;
      isActive: boolean;
    };
  };
}

export interface GetLinkServiceNearInput {
  latitude: number;
  longitude: number;
}

export const useGetLinkServiceNear = (
  onCompleted?: (data: GetLinkServiceNearQuery) => void
) => {
  return useLazyQuery<GetLinkServiceNearQuery>(GET_LINKSERVICE_NEAR_QUERY, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
